module.exports = __webpack_public_path__ + "img/img10.669c780.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/01/img10.png
// module id = 165
// module chunks = 0